import { ChevronDown, Home, Lock, LogOut, Maximize, Minimize, PanelLeftClose, PanelLeftOpen, Globe } from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { setBranchCode, setOpen } from '../../Redux/Services/headerSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData } from '../CommonComponents/CustomHooks';
import { CommonApiData, deleteCookie, virtualPath } from '../CommonComponents/EnvConfig';
import { GetSession, RemoveSession } from '../CommonComponents/criptoUtils';
import { setCurrentLanguage } from '../../Redux/Services/settingSlice';
import { retranslateAll } from '../CommonComponents/TranslationObserver';

export const toggleFullScreen = (event, ID, setIsFullScreen, isFullScreen) => {
    if (!isFullScreen) {
        let element = document.documentElement;
        if (ID !== undefined && ID !== '') {
            element = document.getElementById(ID);
        }
        if (element) {
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen();
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
            element.style.overflow = 'auto';
            setIsFullScreen(true);
        }
    } else {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        document.body.style.overflow = 'auto';
        setIsFullScreen(false);
    }
};

const Header = () => {
    const dispatch = useDispatch();
    const open = useSelector((state) => state.header.open);
    const [isFullScreen, setIsFullScreen] = useState(false);
    const [isDropdown, setIsDropdown] = useState(false);
    const { currentLanguage, translations, layoutConfig } = useSelector((state) => state.settings);
    const userprofile = GetSession('localstorage', 'ProfilePic');
    const user = GetSession('cookies', 'clientUser')
    const navigate = useNavigate();
    const data = CommonApiData();
    const [isLangDropdown, setIsLangDropdown] = useState(false);
    const [formData, setFormData] = useState({
        searchingNo: "",
        searchingType: "AWBNo"
    })
    const GetLanguageType = DropDownData('GetLanguageType');
    const Logout = async () => {
        let data = await ApiCall('/api/UserLogin/Logout', {});
        if (data.status === 'SUCCESS') {
            sessionStorage.setItem('isLoggingOut', 'true');
            deleteCookie('clientUser');
            RemoveSession("cookies", 'clientUser');
            localStorage.removeItem('branch_value');
            localStorage.removeItem('branch_change');
            dispatch(setBranchCode(''));
            NotificationSound(data.status, data.message || 'Successfully Logout');
            navigate('/');
        }
    };
    useEffect(() => {
        document.body.classList.add('light');
    }, []);


    const changeLanguage = (lang) => {
        dispatch(setCurrentLanguage(lang));
        setIsLangDropdown(false);
        // Translate immediately after changing Redux store
        setTimeout(() => {
            retranslateAll();
        }, 100);
    };

    useEffect(() => {
        const savedBranch = localStorage.getItem('branch_value');
        if (savedBranch) {
            dispatch(setBranchCode(savedBranch));
        }
        else if (user?.loginBranch) {
            dispatch(setBranchCode(user.loginBranch));
        }
    }, []);

    useEffect(() => {
        if (!user?.token) {
            const isLoggingOut = sessionStorage.getItem('isLoggingOut') === 'true';
            if (isLoggingOut) {
                sessionStorage.removeItem('isLoggingOut');
            } else {
                NotificationSound('EXPIRED', 'EXPIRED');
            }
        }
    }, [user]);


    return (
        <nav className="sticky top-0 left-0 right-0 bg-white shadow-md md:z-40 z-10">
            <div className="flex items-center justify-between px-6 h-16">
                {/* Left Section - Logo & Navigation */}
                <div className="flex items-center gap-6">
                    {/* Logo */}
                    <div className="toggle-icon text-gray-700 hover:text-gray-900 cursor-pointer transition-colors" onClick={() => dispatch(setOpen(!open))}>
                        {open ? <PanelLeftClose /> : <PanelLeftOpen />}
                    </div>
                </div>
                <div className='flex items-center gap-2'>
                    <div className="hidden md:flex shadow-sm rounded-md overflow-hidden border border-gray-200 h-8 items-center bg-white">
                        <div
                            className="flex-grow-0 h-full text-[12px] bg-gray-50 text-gray-600 flex items-center justify-center px-3 border-r border-gray-200 font-medium"
                            id='txtSearchingType'
                        >
                            {formData.searchingType === "AWBNo" ? "Docket No" : formData.searchingType}
                        </div>

                        <input
                            type="text"
                            className="flex-1 h-full border-0 focus:ring-0 text-sm px-3 outline-none bg-transparent"
                            id='txtSearchingText'
                            placeholder="Enter Docket No"
                            value={formData.searchingNo}
                            autoFocus
                            onChange={(e) => setFormData({ ...formData, searchingNo: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    e.preventDefault();
                                    if (formData.searchingNo === '') {
                                        NotificationSound('ERROR', 'Please enter Docket No.!')
                                        return;
                                    }
                                    window.open(
                                        `${virtualPath}/Query/AwbNoQuery?SearchingNo=${formData.searchingNo}`,
                                        "_blank"
                                    );
                                    setFormData({ ...formData, searchingNo: "" });
                                }
                            }}
                        />
                    </div>
 
                </div>
                {/* Language Dropdown */}
                
                <div className="flex items-center gap-1 sm:gap-2">
                    <div className="relative">

                        <button
                            onClick={() => setIsLangDropdown(!isLangDropdown)}
                            className="cursor-pointer p-1.5 nav-header-hover rounded-lg transition-colors flex items-center gap-1"
                            title="Change Language"
                        >
                            <Globe size={16} className="nav-header-icon" />
                            <span className="text-[11px] font-semibold nav-header-text hidden lg:block uppercase">{currentLanguage || "Default"}</span>
                            <ChevronDown size={12} className={`nav-header-icon transition-transform duration-200 ${isLangDropdown ? 'rotate-180' : ''}`} />
                        </button>
                        {isLangDropdown && (
                            <>
                                <div
                                    className="fixed inset-0 z-40"
                                    onClick={() => setIsLangDropdown(false)}
                                ></div>
                                <div className="absolute right-[-40px] md:right-0 mt-2 w-36 bg-white dark:bg-slate-800 rounded-xl shadow-lg border border-gray-100 dark:border-slate-700 py-1 z-[60] animate-fade-in">
                                    {[...(translations?.langs?.length > 0 ? translations.langs : (GetLanguageType?.data?.dropDownData?.map(l => l.textPart) || []))].map(lang => (
                                        <button
                                            key={lang}
                                            onClick={() => changeLanguage(lang)}
                                            className={`cursor-pointer w-full text-left px-4 py-2 text-sm transition-colors ${(currentLanguage || 'English').toUpperCase() === lang.toUpperCase() ? 'text-blue-600 dark:text-blue-400 font-bold bg-blue-50/50 dark:bg-blue-900/30' : 'text-gray-700 dark:text-slate-200 hover:bg-gray-100 dark:hover:bg-slate-700'}`}
                                        >
                                            {lang}
                                        </button>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                    <button
                        onClick={(event) => toggleFullScreen(event, '', setIsFullScreen, isFullScreen)}
                        className="p-2 hover:bg-gray-100 rounded-lg transition-colors hidden lg:block text-gray-500 hover:text-gray-700"
                        title="Toggle Fullscreen"
                    >
                        {!isFullScreen ? (
                            <Maximize size={20} />
                        ) : (
                            <Minimize size={20} />
                        )}
                    </button>

                    {/* User Dropdown */}
                    <div className="relative">
                        <button
                            onClick={() => setIsDropdown(!isDropdown)}
                            className="flex items-center gap-2 px-2 py-1.5 hover:bg-gray-100 rounded-lg transition-all group shrink-0"
                        >
                            <div className="text-right hidden md:flex md:flex-col items-end shrink-0">
                                <p className="text-sm font-semibold text-gray-800 flex items-center gap-2 leading-tight">
                                    <span className="w-2 h-2 bg-green-500 rounded-full animate-pulse shrink-0"></span>
                                    <span className='text-nowrap'>{data?.userName || '----'}</span>
                                </p>
                                <p className="text-[10px] text-gray-500 font-medium leading-tight mt-0.5 pr-0.5">
                                    {data?.loginUserCode || ''}
                                </p>
                            </div>
                            <div className="relative shrink-0 ml-1">
                                <img
                                    src={userprofile || `https://ui-avatars.com/api/?name=${data?.userName || "User"}&background=4179a5&color=fff&bold=true`}
                                    alt="user"
                                    className="w-9 h-9 rounded-full border-2 border-gray-200 object-cover shadow-sm"
                                    onError={(e) => {
                                        e.target.src = `https://ui-avatars.com/api/?name=${data?.userName || "User"}&background=4179a5&color=fff&bold=true`;
                                    }}
                                />
                                <div className="absolute -bottom-0.5 -right-0.5 w-3.5 h-3.5 bg-green-500 rounded-full border-2 border-white"></div>
                            </div>
                            <ChevronDown
                                size={16}
                                className={`text-gray-400 transition-transform duration-200 ${isDropdown ? 'rotate-180' : ''}`}
                            />
                        </button>

                        {/* Dropdown Menu */}
                        {isDropdown && (
                            <>
                                <div
                                    className="fixed inset-0 z-40"
                                    onClick={() => setIsDropdown(false)}
                                ></div>
                                <div className="absolute right-0 mt-2 w-[280px] sm:w-64 bg-white rounded-xl shadow-xl border border-gray-100 py-2 z-50 animate-fade-in origin-top-right transform transition-all">
                                    {/* User Info */}
                                    <div className="px-4 py-3 border-b border-gray-100">
                                        <div className="flex items-center gap-3">
                                            <img
                                                src={userprofile || `https://ui-avatars.com/api/?name=${data?.userName || "User"}&background=4179a5&color=fff&bold=true`}
                                                alt="user"
                                                className="w-12 h-12 rounded-full border-2 border-gray-100 object-cover shadow-sm"
                                                onError={(e) => {
                                                    e.target.src = `https://ui-avatars.com/api/?name=${data?.userName || "User"}&background=4179a5&color=fff&bold=true`;
                                                }}
                                            />
                                            <div>
                                                <p className="text-sm font-bold text-gray-800">{data?.userName || '----'}</p>
                                                <p className="text-xs text-gray-500 font-medium">{data?.loginUserCode || '----'}</p>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Menu Items */}
                                    <div className="py-2">
                                        <Link
                                            to="/Dashboard/Dashboard"
                                            className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition-colors"
                                            onClick={() => setIsDropdown(false)}
                                        >
                                            <Home size={18} className="text-gray-500" />
                                            <span className="text-sm font-medium text-gray-700">Dashboard</span>
                                        </Link>

                                        <Link
                                            to="/ClientUser/ChangePassword"
                                            className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition-colors"
                                            onClick={() => setIsDropdown(false)}
                                        >
                                            <Lock size={18} className="text-[#4179a5]" />
                                            <span className="text-sm font-medium text-gray-700">Change Password</span>
                                        </Link>
                                    </div>

                                    {/* Divider */}
                                    <div className="border-t border-gray-100 my-1"></div>

                                    {/* Logout */}
                                    <button
                                        onClick={() => {
                                            Logout();
                                            setIsDropdown(false);
                                        }}
                                        className="flex items-center gap-3 px-4 py-2.5 hover:bg-gray-50 transition-colors w-full text-left group"
                                    >
                                        <div className="p-1.5 bg-red-50 rounded-lg group-hover:bg-red-100 transition-colors">
                                            <svg
                                                id="Exit_Door"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 512 512"
                                                className='w-5'
                                            >
                                                <defs>
                                                    <style>{"\n      .st0 {\n        fill: #dd2a2a;\n      }\n    "}</style>
                                                </defs>
                                                <path
                                                    className="st0"
                                                    d="M497.6,32.2L337.6.2c-2.4-.5-4.8.1-6.6,1.7-1.9,1.5-2.9,3.8-2.9,6.2v24h-152c-4.4,0-8,3.6-8,8v48c0,4.4,3.6,8,8,8s8-3.6,8-8v-40h144v16h-120c-4.4,0-8,3.6-8,8v24c0,4.4,3.6,8,8,8s8-3.6,8-8v-16h112v416h-120c-4.4,0-8,3.6-8,8s3.6,8,8,8h288c4.4,0,8-3.6,8-8V40c0-3.8-2.7-7.1-6.4-7.8ZM488,496h-144V17.8l144,28.8v449.4Z"
                                                />
                                                <path d="M368,296c4.4,0,8-3.6,8-8v-32c0-4.4-3.6-8-8-8s-8,3.6-8,8v32c0,4.4,3.6,8,8,8Z" />
                                                <path d="M168,192c22.1,0,40-17.9,40-40s-17.9-40-40-40-40,17.9-40,40,17.9,40,40,40ZM168,128c13.2,0,24,10.8,24,24s-10.8,24-24,24-24-10.8-24-24,10.8-24,24-24Z" />
                                                <path d="M192.5,360.8l-39-27.9,10.7-32.2,8.4,10.1c4.6,5.5,10.9,9.3,17.7,10.7l44.3,9.8c7.2,1.6,14.7-.1,20.4-4.8,5.7-4.6,9-11.5,9-18.9,0-10.5-6.7-19.8-16.6-23l-34-11.4-23.5-41.2c-5.4-9.3-13.4-16.8-23-21.7l-7.3-3.7c-15.2-7.6-32.9-6.7-47.2,2.4-.2,0-.3.2-.4.3l-54.7,12.2c-9.4,2.1-17.2,8.3-21.6,16.9l-21.1,42c-3.1,6-3.5,13.1-1.1,19.4,2.4,6.4,7.4,11.4,13.6,13.9,2.9,1.2,6,1.8,9.1,1.8,8.3,0,16.2-4.5,20.7-11.7l20-32.8,6.2-1.1-13.2,50.2c-2,7.4-1.6,15.3.7,22.5l-38.9,133.6c-.7,2.6-1.1,5.1-1.1,7.8,0,15.3,12.5,27.8,27.8,27.8s21.7-7,25.9-17.7l40.3-103.6,19,13.3-6.1,80.1c-.6,7.2,1.9,14.4,6.8,19.7,4.9,5.3,11.8,8.3,19,8.3,12.7,0,23.5-9.1,25.6-21.6l16.5-98.2c2-12.1-2.9-24.1-12.9-31.4h0ZM70.6,256.1c-2.3.4-4.2,1.8-5.4,3.7l-21.9,35.9c-2.1,3.3-6,5.1-10.1,3.4-2.2-.9-3.8-2.5-4.7-4.7-.8-2.2-.7-4.5.4-6.6l21.1-42c2.2-4.3,6.2-7.5,10.8-8.5l33.7-7.5c-1.1,2.5-2.1,5-2.8,7.7l-4.1,15.5-17,3h0ZM69.4,488.5c-1.8,4.6-6.1,7.5-11,7.5s-11.8-5.3-11.8-11.8.2-2.3.5-3.4l35.1-120.4c1.1,1,2.2,2,3.5,2.8l25.5,17.8-41.7,107.3h0ZM189.6,389.5l-16.5,98.2c-.8,4.8-4.9,8.3-9.8,8.3s-5.3-1.1-7.2-3.2c-1.9-2.1-2.8-4.8-2.6-7.6l6.5-84.6c.2-2.8-1.1-5.5-3.4-7.2l-61.7-43.2c-3.8-2.7-6.7-6.3-8.4-10.6-2-4.8-2.4-10.1-1-15.2l16.4-62.5v-.2c0,0,5.3-20.1,5.3-20.1,2.1-7.9,7-14.6,13.8-18.9,5.3-3.3,11.2-5,17.1-5s9.8,1.1,14.3,3.4l7.3,3.7c6.9,3.5,12.5,8.8,16.3,15.4l25,43.8c1,1.7,2.5,3,4.4,3.6l36.9,12.3c3.3,1.1,5.6,4.2,5.6,7.8s-1.1,4.8-3.1,6.4c-2,1.6-4.5,2.2-7,1.6l-44.3-9.9c-3.4-.7-6.5-2.7-8.8-5.4l-17.5-21c0,0-.1-.1-.2-.2l-17-20.4c-2.8-3.4-7.9-3.9-11.3-1-3.4,2.8-3.9,7.9-1,11.3l14.3,17.1-15.7,47.2c-1.1,3.3,0,7,2.9,9l43.8,31.3c4.9,3.6,7.5,9.7,6.5,15.7h0Z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <span className="text-sm font-medium text-gray-700">Logout</span>
                                            <p className="text-xs text-gray-500">Sign out from system</p>
                                        </div>
                                    </button>
                                </div>
                            </>
                        )}
                    </div>

                </div>
            </div>
        </nav>
    );
};

export default Header;